import "./MuscleDetailFilterDropdown.css";

import React, { useMemo, useState } from "react";
import { Col, Dropdown, FormGroup } from "react-bootstrap";

import CheckedIcon from "../../assets/imgs/checked-icon.svg";
import FilterIcon from "../../assets/imgs/filter-icon.svg";
import DefaultButton from "../../components/DefaultButton/DefaultButton";
import TextInput from "../../components/TextInput/TextInput";

const normalizeText = (value) =>
  (value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();

const MuscleDetailFilterDropdown = ({
  options = [],
  selectedRegions = [],
  onChange,
  onClear,
  triggerLabel = "Filtros",
  triggerIcon = FilterIcon,
  triggerVariant = "filter",
  clearLabel = "Limpar filtros",
  searchPlaceholder = "Buscar área muscular",
  emptySearchMessage = "Nenhuma área encontrada",
}) => {
  const [showFilters, setShowFilters] = useState(false);
  const [filterSearch, setFilterSearch] = useState("");

  const isFilterPressed = showFilters || selectedRegions.length > 0;
  const isPrimaryTrigger = triggerVariant === "primary";

  const visibleOptions = useMemo(() => {
    const normalizedSearch = normalizeText(filterSearch);
    if (!normalizedSearch) {
      return options;
    }

    return options.filter((option) =>
      normalizeText(option.label).includes(normalizedSearch)
    );
  }, [filterSearch, options]);

  const toggleRegion = (label) => {
    if (selectedRegions.includes(label)) {
      onChange(selectedRegions.filter((item) => item !== label));
      return;
    }
    onChange([...selectedRegions, label]);
  };

  const handleToggle = (nextShow) => {
    setShowFilters(nextShow);
    if (!nextShow) {
      setFilterSearch("");
    }
  };

  const selectionCount =
    !isPrimaryTrigger && selectedRegions.length > 0 ? (
      <span className="anthropometry-detailed-progress__filter-count">
        {selectedRegions.length}
      </span>
    ) : null;

  return (
    <Dropdown
      className={
        isPrimaryTrigger ? "anthropometry-detailed-progress__add-muscle-dropdown" : undefined
      }
      show={showFilters}
      onToggle={handleToggle}
      autoClose="outside"
    >
      {isPrimaryTrigger ? (
        <DefaultButton
          title={triggerLabel}
          onClick={() => setShowFilters((current) => !current)}
          size="small"
          style="anthropometry-detailed-progress__add-muscle-button"
        />
      ) : (
        <a
          className={`anthropometry-detailed-progress__filter ${
            isFilterPressed ? "anthropometry-detailed-progress__filter--pressed" : ""
          }`}
          href="javascript:;"
          onClick={() => setShowFilters((current) => !current)}
        >
          <img src={triggerIcon} alt="" />
          {triggerLabel}
          {selectionCount}
        </a>
      )}
      <Dropdown.Menu
        bsPrefix={`dropdown-menu anthropometry-detailed-progress__filter__dropdown${
          isPrimaryTrigger
            ? " anthropometry-detailed-progress__filter__dropdown--align-end"
            : ""
        }`}
      >
        <div className="anthropometry-detailed-progress__filter__dropdown__searchSection">
          <div className="anthropometry-detailed-progress__filter__dropdown__searchSection__input">
            <FormGroup as={Col}>
              <TextInput
                type="text"
                placeholder={searchPlaceholder}
                value={filterSearch}
                onChangeText={setFilterSearch}
                size="small"
              />
            </FormGroup>
          </div>
        </div>

        {visibleOptions.length > 0 ? (
          visibleOptions.map((option) => {
            const isSelected = selectedRegions.includes(option.label);
            return (
              <Dropdown.Item
                key={option.label}
                as="button"
                className="anthropometry-detailed-progress__filter__dropdown__item"
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  toggleRegion(option.label);
                }}
              >
                <div
                  className={`anthropometry-detailed-progress__filter__dropdown__checkbox${
                    isSelected ? " checkbox--checked" : ""
                  }`}
                >
                  <img src={CheckedIcon} alt="Checked icon" />
                </div>
                <p className="dropdown-item__text">{option.label}</p>
              </Dropdown.Item>
            );
          })
        ) : (
          <p className="anthropometry-detailed-progress__filter__dropdown__empty">
            {emptySearchMessage}
          </p>
        )}

        {selectedRegions.length > 0 && (
          <Dropdown.Item
            as="button"
            className="anthropometry-detailed-progress__filter__dropdown__clear"
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              onClear();
            }}
          >
            {clearLabel}
          </Dropdown.Item>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default MuscleDetailFilterDropdown;
